import React from "react";
import styled from "styled-components";
import { Button } from "../Button";
import Portal from "../common/Portal";
import { SvgCloseLarge } from "../Svgs/CloseLarge";
import { Body1, H2 } from "../Text";
import { colors } from "../Theme/colors";
import { Div } from "../utils";
import { useOverlay } from "../utils/hooks";
export const ModalContainer = styled(Div) `
  top: 0px;
  left: 0px;
  margin: 0px;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  margin-top: 8vh;
  pointer-events: none;
  div {
    pointer-events: auto;
  }
`;
export const ModalBackdrop = styled(Div) `
  position: fixed;
  top: 0px;
  left: 0px;
  margin: 0px;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  background: black;
  opacity: 0.8;
`;
export const ModalWrapper = styled(Div) `
  background: ${(props) => props.theme.colors.white};
  padding: 38px 48px;
  border-radius: 8px;
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  max-height: 80vh;
  margin-bottom: 100px;
  ${(props) => props.theme.mediaQueries.mobile} {
    width: 70vw;
    padding: 30px;
  }
  ${(p) => p.theme.css.scrollbarDark};
`;
export const ModalCloseIcon = styled(Div) `
  height: 0;
  display: flex;
  flex-direction: row-reverse;
`;
const ModalTypes = ["small", "medium", "large"];
const modalWidths = {
    small: 476,
    medium: 676,
    large: 876,
};
export const Modal = ({ isOpen = false, onClose = () => { }, header, body, variant = "small", children, withCloseIcon = true, withBackdropClose = true, className = "", confirmation, }) => {
    useOverlay(isOpen);
    const headerUI = (React.createElement(Div, { spaceBetween: true },
        React.createElement(H2, null, header),
        withCloseIcon && (React.createElement(ModalCloseIcon, null,
            React.createElement(Div, { clickable: true, onClick: onClose, c: colors.black60 },
                React.createElement(SvgCloseLarge, null))))));
    const confirmationUI = confirmation && (React.createElement(Div, { justifyEnd: true, mt: 32 },
        React.createElement(Div, { dflex: true },
            React.createElement(Button, { w: 82, variant: "tertiary", onClick: onClose }, "Cancel"),
            React.createElement(Button, { variant: confirmation.variant, ml: 20, dInline: true, onClick: () => {
                    confirmation === null || confirmation === void 0 ? void 0 : confirmation.onConfirm();
                    onClose();
                } }, confirmation.label || "Confirm"))));
    return (React.createElement(React.Fragment, null, isOpen && (React.createElement(Portal, null,
        React.createElement(Div, { className: className },
            React.createElement(ModalBackdrop, { onClick: () => {
                    if (withBackdropClose)
                        onClose();
                } }),
            React.createElement(ModalContainer, null,
                React.createElement(ModalWrapper, { w: modalWidths[variant] },
                    headerUI,
                    React.createElement(Div, null,
                        body && React.createElement(Body1, { mt: 20 }, body),
                        children),
                    confirmationUI)))))));
};
//# sourceMappingURL=index.js.map